/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SetDeviceFeatureMemberRequest } from '../models/SetDeviceFeatureMemberRequest';
import type { SuccessListDeviceFeatureStatusResponse } from '../models/SuccessListDeviceFeatureStatusResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WithingsDeviceFeatureControllerService {

    /**
     * Get feature statuses for the member's Withings devices
     * Returns the current enabled/disabled state and device compatibility for all known feature modes. If the user has no compatible Withings device, the modes are returned with available=false.
     * @returns SuccessListDeviceFeatureStatusResponse Feature statuses returned successfully
     * @throws ApiError
     */
    public static fetchMemberDeviceFeatureStatuses(): CancelablePromise<SuccessListDeviceFeatureStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/users/me/withings/devices/features',
            errors: {
                400: `Withings API error`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `No Withings token found for the member`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

    /**
     * Enable or disable a Withings device feature
     * Enables or disables a feature (Eyes Closed mode, Body Composition measurements) on the specified device model.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static setMemberDeviceFeature(
        requestBody: SetDeviceFeatureMemberRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/users/me/withings/devices/features',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Withings API error`,
                401: `The client is not authorized to perform the action. The \`code\`, \`message\`, and \`data\` fields may provide more information about the reason of the error.`,
                404: `No device or token found for user`,
                500: `An unexpected error has occurred.`,
            },
        });
    }

}
